import {
  MetricsOption,
  MetricData,
  TrendCategory,
} from '@amzn/aet-galactus-kit';

export interface TrendAndDetailsMetrics {
  readonly userID: string;
  readonly metricTypes: MetricsOption[];
  readonly latestMetricPublishDate: string;
  readonly metricDatas?: MetricData;
}

export const TrendCategoryDefaultName = new Map<
  TrendCategory,
  [string, string]
>([
  [
    TrendCategory.COMPLIANCE,
    ['cs_perfportal_metrics_compliance', 'Compliance'],
  ],
  [
    TrendCategory.EFFICIENCY,
    ['cs_perfportal_metrics_efficiency', 'Efficiency'],
  ],
  [TrendCategory.OTHER, ['cs_perfportal_metrics_other', 'Other']],
  [TrendCategory.QUALITY, ['cs_perfportal_metrics_quality', 'Quality']],
]);

export type TeamDetailsMetricsPerUser = {
  [user: string]: { [metricName: string]: string };
};

export type BottomQuartileData = {
  userFullName: string;
  userAlias: string;
  metricName?: string;
  metricValue?: string;
  networkAvg?: string;
  benchmarkDiff?: string;
};

export type CsaInfoMap = { [userId: string]: string };

export enum BottomQuartileCategory {
  ONE = 'ONE',
  TEN = 'TEN',
  TWENTY_FIVE = 'TWENTYFIVE',
}

export enum BottomQuartileMap {
  CCX_NEG_ONEBOX = 'CCX_NEG_ONEBOX', // remove once CCX B2B is entirely rolled out
  CCX_NEG = 'CCX_NEG',
  RAP = 'RAP',
}

export type DataPerUser = Record<
  string,
  {
    fullName?: string;
    [key: string]: any;
  }
>;

export type SortType = 'metric' | 'benchmark_diff';

export enum DIRECT_REPORT_TYPE {
  TM = 'TM',
  ASSOCIATE = 'Associate',
}
